import { chromeWord } from '@shared/branding';
import { useBranding } from '../state';

/**
 * "learn." in Baloo 800 with a signal-coloured stop.
 *
 * Ported from website-cloud's `Wordmark.tsx` — same reasoning applies here:
 * the design system's own `Wordmark` component cannot express the two-tone
 * stop, so this app draws it by hand rather than losing that detail.
 *
 * ── Under an organisation's branding ────────────────────────────────────────
 * The word comes from the organisation when it has set one, and the tile from
 * its logo when it has uploaded one. Both fall back to Mauvely's, which is
 * what every account in no organisation gets. The stop stays signal-coloured
 * regardless — the mark's one flash of semantic colour, not the accent.
 */

interface Props {
  /** Height of the word in px. */
  size?: number;
  /** Draw the product tile ahead of the mark. */
  showMark?: boolean;
}

export function Wordmark({ size = 20, showMark = false }: Props) {
  const display = "var(--font-display), 'Baloo 2', system-ui";
  const branding = useBranding();
  const word = chromeWord(branding, 'learn');

  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: showMark ? 9 : 0 }}>
      {showMark && (
        <img
          src={branding?.logoUrl ?? '/brand/lms.svg'}
          alt=""
          aria-hidden="true"
          width={size + 5}
          height={size + 5}
          style={{
            alignSelf: 'center',
            borderRadius: 6,
            flex: 'none',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      )}
      <span style={{ fontFamily: display, fontWeight: 800, fontSize: size, color: 'var(--text-strong)' }}>
        {word}
        <span style={{ color: 'var(--signal)' }}>.</span>
      </span>
    </span>
  );
}
